import {
  AccountTypes,
  IndividualDesignationListedTypes,
  IRADesignationListedTypes,
  IRATrustTypes,
  YesNoEmpty,
} from '@interfaces/models';

export interface AccountTriageState {
  accountTypeInheriting: AccountTypes;
  isSpouse: string;
  IRADesignation: IRADesignationListedTypes;
  individualDesignation: IndividualDesignationListedTypes;
  isOnlyBeneficiary: YesNoEmpty;
  isOnlyExecutor?: YesNoEmpty;
  isOnlyTrustee?: YesNoEmpty;
  isNotOnlyInheritingAccount?: boolean;
  isOnlyChild?: boolean;
  wasAccountPreviouslyInherited?: YesNoEmpty;
  originalDecedentName?: string;
  wasMarried?: YesNoEmpty;
  isDecedentSpouse?: YesNoEmpty;
  typeOfTrust?: IRATrustTypes;
}

export const JOINT_ACCOUNTS_TYPES = [
  AccountTypes.JOINT,
  AccountTypes.JOINT_COMMUNITY_PROPERTY,
  AccountTypes.JOINT_TENANTS_WROS,
];
